<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 19:40:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-24 10:29:38
-->
<template>
	<div v-if="showPartner">
		<p>
			<span class="mr-4">{{ row.bd_partner_name }}</span>
			<el-tag v-if="row.bd_partner_info.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
			<el-tag v-else-if="row.bd_partner_info.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
		</p>
		<template v-if="row.bd_partner_rate != '--'">
			<p>提成比：{{ row.bd_partner_rate }}%</p>
			<p>预估提成：¥{{ row.bd_partner_commission_fee }}</p>
			<p>实际提成：¥{{ row.bd_partner_real_commission_fee }}</p>
		</template>
		<p v-else-if="$auth.hasPermi('system:Order:Investment-operation')">
			<span>提成比：</span>
			<el-tooltip content="未对该员工设置提成，请去【团队管理-子账号管理】进行设置">
				<span>未设置</span>
			</el-tooltip>
		</p>
	</div>
</template>
<script>
import mixin from './mixin';

export default {
	mixins: [mixin],
	computed: {
		showPartner() {
			return !!this.row?.bd_partner_name;
		},
	},
};
</script>

<style lang="less" scoped></style>
